import React, { ReactElement } from "react";
import "./Checkbox.css";

interface CheckboxProps {
  disabled?: boolean;
  checked: boolean;
  onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
  onKeyPress: (ev: React.KeyboardEvent<HTMLDivElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  disabled = false,
  checked = false,
  onClick,
  onKeyPress,
  ...rest
}): ReactElement => {
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        {...rest}
        checked={checked}
        aria-checked={checked}
        className="hidden-checkbox"
      />
      <div
        role="checkbox"
        aria-checked={checked}
        className={`styled-checkbox ${checked ? "" : "un"}checked ${disabled ? "disabled" : ""}`}
        tabIndex={0}
        onClick={onClick}
        onKeyPress={onKeyPress}
        {...rest}
      >
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
    </div>
  );
};

// Checkbox.defaultProps = {
// checked: false,
// };

export default Checkbox;
